<template>
    <div>
        <v-card
                class="flex"
                flat
                tile>
            <v-card-title class="info">
                <div class="caption">
                    <a href="https://eudoxus.gr/Files/Terms_and_Conditions_Plus.pdf" target="_blank">Όροι/προϋποθέσεις
                        συμμετοχής.</a><br/>
                    Για οποιαδήποτε απορία μπορείτε να επικοινωνείτε με το Γραφείο Αρωγής Χρηστών
                    <a href="https://eudoxus.gr/OnlineReport.aspx" target="_blank">online</a> ή τηλεφωνικά στο 215 215
                    7850. <br/>
                    Η εφαρμογή είναι συμβατή με τους φυλλομετρητές Internet Explorer 10, Mozilla Firefox 45, Google
                    Chrome
                    61, Safari 10.1.2 ή νεώτερους. Η χρήση της εφαρμογής ενδέχεται να είναι δυνατή και από άλλους
                    φυλλομετρητές αλλά με ευθύνη του χρήστη.
                </div>
            </v-card-title>
            <a href="https://www.espa.gr/en/Pages/default.aspx/" target="_blank">
              <v-img :src="require('../assets/BANNER_MDT_ETPA2.jpg')" height="80px" contain alt="Ανακατεύθυνση σε ΕΣΠΑ"></v-img>
            </a>
            <v-card-actions class="black--text justify-center footerText">
                <strong @click="showCreator()">©2022 — Εύδοξος</strong>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: "FooterComponent",
        data: () => ({
                counter: 5
        }),
        methods: {
            showCreator() {
                this.counter--;
                if (this.counter == 0)  {
                    console.log("Καρύδης Ξενοφών && Κιτσούλης Ευάγγελος");
                    this.counter = 5;
                }
            }
        }
    }
</script>

<style scoped>

    .footerText {
        font-size: x-small;
        color: white;
    }

</style>
